/* Theme-owned Australian cart protection; no app server or vendor script dependency. */
(function () {
  'use strict';
  const configNode = document.getElementById('owned-protection-config');
  if (!configNode || !window.OwnedProtectionCore) return;
  const config = JSON.parse(configNode.textContent);
  config.variants = (config.variantIds || []).map((id,index) => ({
    id, title: config.variantTitles[index], price: config.variantPrices[index], available: config.variantAvailability[index]
  })).filter(v => !v.title.startsWith('*'));
  const core = window.OwnedProtectionCore;
  const template = document.getElementById('owned-protection-template');
  const storageKey = 'owned-shipping-protection:selected';
  let enabled = true;
  try { enabled = localStorage.getItem(storageKey) !== 'false'; } catch (_) {}
  let snapshot, working = false, refreshing = false, refreshAgain = false, timer, errorText = '';
  let mutationVersion = 0, checkoutButton, activeRefresh;
  function resetCheckoutButton() {
    if (!checkoutButton) return;
    checkoutButton.removeAttribute('aria-busy');
    checkoutButton.classList.remove('owned-checkout-busy');
    checkoutButton = undefined;
  }
  let snapshotVersion = -1, lastQuantityInteraction = 0;
  const pending = new Set();
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const nativeFetch = window.fetch.bind(window);
  let traceStart = 0;
  const tracing = new URLSearchParams(location.search).has('protection_trace');
  function trace(stage) { if (tracing && traceStart) console.info('[protection timing]', stage, Math.round(performance.now() - traceStart)); }
  window.addEventListener('pagehide', () => trace('pagehide'));
  async function request(path, body) {
    trace('request ' + path);
    const response = await nativeFetch(root + path, {
      credentials: 'same-origin', cache: 'no-store',
      ...(body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {})
    });
    trace('response ' + path);
    if (!response.ok) throw new Error('We could not update shipping insurance. Please try Checkout again.');
    return response.json();
  }
  function updateTheme() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  const controller = core.createController(config, {
    read: () => request('cart.js'),
    remove: async keys => {
      const result = await request('cart/update.js', {updates:Object.fromEntries(keys.map(key => [key,0]))});
      updateTheme();
      return result;
    },
    add: id => request('cart/add.js',{items:[{id,quantity:1}]}),
    setProtection: (id, cart) => {
      const insurance = cart.items.filter(item => core.isProtection(item,config));
      const existing = insurance.find(item => String(item.variant_id) === String(id));
      const updates = Object.fromEntries(insurance.map(item => [item.key, item === existing ? 1 : 0]));
      if (id && !existing) updates[id] = 1;
      return request('cart/update.js',{updates});
    }
  });
  function isCartWrite(url) {
    try { const parsed = new URL(url,location.href); return parsed.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(parsed.pathname); } catch (_) { return false; }
  }
  function affectsPricing(url, body) {
    if (!isCartWrite(url)) return false;
    return !(/\/cart\/update(?:\.js)?$/.test(new URL(url,location.href).pathname) && core.isTrackingOnlyUpdate(body));
  }
  function settled(operation) {
    trace("external cart write started");
    mutationVersion++;
    pending.add(operation);
    operation.finally(() => { trace("external cart write finished"); pending.delete(operation); mutationVersion++; schedule(); }).catch(() => {});
  }
  // Observe existing cart writers, preserving their responses and errors. Own writes use nativeFetch.
  window.fetch = function (input, options) {
    const operation = nativeFetch(input, options);
    if (affectsPricing(typeof input === 'string' ? input : input.url, options?.body)) {
      settled(operation);
    }
    return operation;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  const observed = new WeakMap();
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) observed.set(this,url); else observed.delete(this);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (observed.has(this) && affectsPricing(observed.get(this), arguments[0])) {
      let finish;
      const operation = new Promise(resolve => { finish = resolve; });
      this.addEventListener('loadend', finish, {once:true});
      settled(operation);
      try { return xhrSend.apply(this,arguments); } catch (error) { finish(); throw error; }
    }
    return xhrSend.apply(this,arguments);
  };
  let moneyFormatter, formatterCurrency;
  function money(amount) {
    const currency = snapshot?.cart.currency || config.currency || 'AUD';
    if (currency !== formatterCurrency) {
      formatterCurrency = currency;
      moneyFormatter = new Intl.NumberFormat('en-AU',{style:'currency',currency});
    }
    return moneyFormatter.format(amount/100);
  }
  function setText(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function mount() {
    document.querySelectorAll('cart-drawer .tax-note,.cart__footer .tax-note').forEach(target => {
      if (!target.parentElement.querySelector('[data-owned-protection]')) target.before(template.content.cloneNode(true));
    });
  }
  function render() {
    mount();
    document.querySelectorAll('[data-owned-protection]').forEach(widget => {
      widget.hidden = !snapshot?.quote;
      if (snapshot) {
        widget.dataset.cartInsuranceLines = String(snapshot.cart.items.filter(item => core.isProtection(item,config)).length);
        widget.dataset.cartMerchandiseQuantity = String(snapshot.cart.items.filter(item => !core.isProtection(item,config)).reduce((count,item) => count + item.quantity,0));
      }
      const input = widget.querySelector('input');
      input.checked = enabled;
      input.disabled = working;
      input.setAttribute('aria-checked',String(enabled));
      setText(widget.querySelector('[data-protection-price]'), snapshot?.quote ? '(' + money(snapshot.quote.price) + ')' : '');
      setText(widget.querySelector('[data-protection-description]'), enabled
        ? '100% Payment guarantee & Protect your order from damage, loss, or theft.'
        : 'By deselecting shipping insurance, we are not liable for lost, damaged, or stolen items.');
      const error = widget.querySelector('[role="alert"]');
      error.hidden = !errorText; setText(error,errorText);
    });
    if (snapshot) {
      const fee = enabled && snapshot.quote ? snapshot.quote.price : 0;
      const total = snapshot.cart.total_price + fee;
      document.querySelectorAll('.totals__subtotal-value').forEach(node => setText(node,money(total) + ' ' + snapshot.cart.currency));
    }
  }
  async function refresh() {
    if (working) return;
    if (refreshing) { refreshAgain = true; return; }
    refreshing = true;
    const version = mutationVersion;
    try {
      activeRefresh = controller.browse();
      snapshot = await activeRefresh; snapshotVersion = version; errorText = ''; render();
    }
    catch (error) { snapshotVersion = -1; errorText = error.message; render(); }
    finally { activeRefresh = undefined; refreshing = false; if (refreshAgain) { refreshAgain = false; schedule(); } }
  }
  function schedule() {
    if (working) return;
    clearTimeout(timer); timer = setTimeout(refresh,80);
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-owned-protection] input')) return;
    enabled = event.target.checked;
    try { localStorage.setItem(storageKey,String(enabled)); } catch (_) {}
    render();
  });
  ['cart:updated'].forEach(name => document.addEventListener(name,schedule));
  let renderFrame = 0;
  const observer = new MutationObserver(records => {
    if (renderFrame || !records.some(record => !record.target.parentElement?.closest('[data-owned-protection]') && !record.target.closest?.('[data-owned-protection]'))) return;
    renderFrame = requestAnimationFrame(() => { renderFrame = 0; render(); });
  });
  observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('click',event => {
    if (event.target.closest?.('quantity-input button,.quantity button,.quantity a')) lastQuantityInteraction = performance.now();
  },true);
  function intercept(event) {
    // Only checkout submissions belong to protection; let popup and other forms handle their own submit.
    if (event.type === 'submit' && !event.submitter?.matches('button[name="checkout"],input[name="checkout"]')) return;
    const button = event.type === 'submit' ? event.submitter : event.target.closest?.('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if (!button) return;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (working) return;
    traceStart = performance.now(); trace('click');
    working = true; errorText = ''; clearTimeout(timer);
    checkoutButton = button;
    button.setAttribute('aria-busy','true');
    button.classList.add('owned-checkout-busy');
    trace('button acknowledged');
    document.documentElement.classList.add('owned-protection-checkout'); render();
    (async () => {
      // Only allow debounce time immediately after a quantity control was used.
      const quantityDelay = 350 - (performance.now() - lastQuantityInteraction);
      if (lastQuantityInteraction && quantityDelay > 0) await new Promise(resolve => setTimeout(resolve,quantityDelay));
      while (pending.size) await Promise.allSettled([...pending]);
      // A cart-open refresh may already be reading Shopify. Reuse its result
      // instead of queuing another read behind it on a quick checkout tap.
      if (activeRefresh) {
        trace('waiting for active cart refresh');
        await activeRefresh.catch(() => {});
        while (pending.size) await Promise.allSettled([...pending]);
      }
      const form = button.form || button.closest('form');
      const note = form?.querySelector('[name="note"]');
      const discount = form?.querySelector('[name="discount"]')?.value.trim();
      if (note) await request('cart/update.js',{note:note.value});
      trace('cart ready');
      const startVersion = mutationVersion;
      let result = await controller.checkout(enabled, !refreshing && snapshotVersion === startVersion ? snapshot?.cart : undefined);
      if (mutationVersion !== startVersion) {
        while (pending.size) await Promise.allSettled([...pending]);
        // Recheck the final cart without removing and re-adding protection.
        controller.invalidateCheckout();
        const retryVersion = mutationVersion;
        result = await controller.checkout(enabled);
        if (pending.size || mutationVersion !== retryVersion) throw new Error("Your cart changed. Please try Checkout again.");
      }
      const actual = result.cart;
      if (!actual.items.some(item => !core.isProtection(item,config))) throw new Error('Please add an item before checking out.');
      trace('insurance verified');
      // Shopify retains native cart discounts and notes at checkout.
      if (discount) location.assign(root + 'checkout?discount=' + encodeURIComponent(discount));
      else location.assign(root + 'checkout');
    })().catch(async error => {
      working = false; resetCheckoutButton(); document.documentElement.classList.remove('owned-protection-checkout');
      try { snapshot = await controller.browse(); } catch (_) {}
      errorText = error.message; render();
    });
  }
  window.addEventListener('click',intercept,true);
  window.addEventListener('submit',intercept,true);
  window.addEventListener('pageshow',() => {
    working = false; resetCheckoutButton(); document.documentElement.classList.remove('owned-protection-checkout'); schedule();
  });
  render(); refresh();
})();
